import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  AbstractComponent,
  AuthenticationService,
  AuthorizationService,
  NavigationService,
  SolDetailsComponent,
  SolErrorPageComponent,
  SolErrorPageType,
  SolLoader,
  SolLoaderComponent,
  SolNavbarComponent,
  SolOverlaysComponent,
  SolPageComponent,
  SolTopbarComponent,
} from '@sol/components';
import { AppState } from './app.state';
import { PrototypeTopbarService } from './services/prototype-topbar.service';

@Component({
  selector: 'app-root',
  imports: [
    NgTemplateOutlet,
    RouterOutlet,
    SolOverlaysComponent,
    SolNavbarComponent,
    SolDetailsComponent,
    SolPageComponent,
    SolTopbarComponent,
    SolLoaderComponent,
    SolErrorPageComponent,
  ],
  templateUrl: './app.component.html',
})
export class AppComponent extends AbstractComponent<AppState> implements OnInit {
  protected readonly SolErrorPageType = SolErrorPageType;
  protected readonly SolLoader = SolLoader;

  // Dependencies
  private readonly authenticationService = inject(AuthenticationService);
  private readonly authorizationService = inject(AuthorizationService);
  private readonly navigationService = inject(NavigationService);
  private readonly prototypeTopbarService = inject(PrototypeTopbarService);

  // Computed
  protected readonly showNavbar$ = this.compute(state => state.showNavbar);
  protected readonly activeRouteStatus$ = this.compute(state => state.activeRouteStatus);
  protected readonly leadingBreadcrumbs$ = this.compute(state => state.leadingBreadcrumbs);

  constructor() {
    super(AppState.of());

    this.prototypeTopbarService.watchComputed(
      topbarState => topbarState.leadingBreadcrumbs,
      leadingBreadcrumbs => this.update(state => state.withLeadingBreadcrumbs(leadingBreadcrumbs)),
    );

    this.navigationService.watchComputed(
      nss => nss.activeRouteStatus,
      status => this.update(state => state.withActiveRouteStatus(status)),
    );
    this.navigationService.watch(nss => {
      const route = nss.activeRoute;
      this.update(state => state.withShowNavbar(route?.showNavbar ?? true));
    });
  }

  ngOnInit(): void {
    this.authenticationService.fetch();
    this.authorizationService.setAuthorities([], true);
  }
}
